import '@/lib/globalEDebugBootstrap';

import Script from 'next/script';
import { useEffect } from 'react';

import { useGlobalECookies } from '@/hooks/useGlobalECookies';
import { GLOBAL_E_MERCHANT_ID, GLOBAL_E_URL } from '@/lib/const';
import {
  GLOBAL_E_SCRIPT_ID,
  isUsableGlobalECartId,
  readGlobalECartIdLikeGlobalE,
} from '@/lib/globalECartId';
import { initGlobalEDebug, logGlobalEDebug } from '@/lib/globalEDebug';
import { useGlobalEContext } from '@/providers/GlobalEProvider/GlobalEProviderContext';

export function GlobalEScript() {
  const { loadScript, notifyScriptError, notifyScriptLoaded } =
    useGlobalEContext();

  useGlobalECookies();

  useEffect(() => {
    initGlobalEDebug();
  }, []);

  const globalECartId = loadScript ? readGlobalECartIdLikeGlobalE() : undefined;

  useEffect(() => {
    (window as Window & { __globalELoadScript?: boolean }).__globalELoadScript =
      loadScript;
    logGlobalEDebug('script:state', {
      loadScript,
      globalECartId,
      willRender: loadScript && isUsableGlobalECartId(globalECartId),
    });
  }, [globalECartId, loadScript]);

  if (!loadScript || !isUsableGlobalECartId(globalECartId)) {
    return null;
  }

  return (
    <Script
      id={GLOBAL_E_SCRIPT_ID}
      onError={notifyScriptError}
      onLoad={notifyScriptLoaded}
      src={`//${GLOBAL_E_URL}/includes/js/${GLOBAL_E_MERCHANT_ID}`}
      strategy='afterInteractive'
    />
  );
}
